import { render, staticRenderFns } from "./LoggingDetail.vue?vue&type=template&id=418c3cae&"
import script from "./LoggingDetail.vue?vue&type=script&lang=js&"
export * from "./LoggingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports